import { Skeleton } from "@mui/material";
import type * as React from "react";

import {
    ArticleInfoBottomContainer,
    ArticleInfoContainer,
    BottomContainer,
    RightContainer,
    RootContainer,
    TopContainer,
} from "./SmallListItem.styles";

interface SmallListItemSkeletonProps {
    showBorderBottom: boolean;
}

export const SmallListItemSkeleton: React.FunctionComponent<SmallListItemSkeletonProps> = ({ showBorderBottom }) => {
    return (
        <RootContainer showBorderBottom={showBorderBottom}>
            <TopContainer>
                <ArticleInfoContainer>
                    <Skeleton height={24} width={150} />

                    <Skeleton height={24} width={100} />

                    <ArticleInfoBottomContainer>
                        <Skeleton height={24} width={100} />

                        <Skeleton height={24} width={50} />
                    </ArticleInfoBottomContainer>
                </ArticleInfoContainer>
            </TopContainer>

            <BottomContainer>
                <Skeleton height={24} width={40} />

                <RightContainer>
                    <Skeleton height={24} width={120} />
                </RightContainer>
            </BottomContainer>
        </RootContainer>
    );
};
